import { Banner } from '@sunwebgroup/uds-ui/banner'
import { IconButton } from '@sunwebgroup/uds-ui/icon-button'
import cn from 'classnames'
import React, { useState } from 'react'
import { useCookie } from 'react-use'
import styles from './EmergencyBanner.module.css'

const COOKIE_EXPIRES_IN_DAYS = 4 / 24

function simpleHash(str: string): string {
  let hash = 5381
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) + hash + str.charCodeAt(i)) & 0xFFFFFFFF
  }
  return Math.abs(hash).toString(16)
}

interface DismissibleBannerProps {
  text: string
  supportingText?: string
  cookieName: string
  dismissAriaLabel: string
}

export function DismissibleBanner({ text, supportingText, cookieName, dismissAriaLabel }: DismissibleBannerProps) {
  const [savedHash, updateHash] = useCookie(cookieName)
  const currentHash = simpleHash((supportingText ?? '') + (text ?? ''))
  const [hasToShow, setHasToShow] = useState(false)

  const handleDismiss = () => {
    updateHash(currentHash, { expires: COOKIE_EXPIRES_IN_DAYS, path: '/', secure: true })
    setHasToShow(false)
  }

  React.useEffect(() => {
    if (savedHash !== currentHash) {
      setHasToShow(true)
    }
  }, [])

  return (
    <div className={cn(styles.bannerWrapper, !hasToShow && styles.bannerWrapperHidden)}>
      <Banner color="warning" size="M" hasIcon display="overlay">
        <Banner.TextsWrapper>
          <Banner.Text>{text}</Banner.Text>
          {supportingText && <Banner.SupportingText innerHTML={supportingText} />}
        </Banner.TextsWrapper>
        <Banner.ActionsWrapper>
          <IconButton
            className={styles.dismissButton}
            glyph="CrossMedium"
            size="S"
            variant="transparent-neutral"
            onClick={handleDismiss}
            aria-label={dismissAriaLabel}
          />
        </Banner.ActionsWrapper>
      </Banner>
    </div>
  )
}
